import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Progress() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/progress").then(({data}) => setItems(data.progress)); }, []);
  return (
    <div className="space-y-6">
      <header><h1 className="font-display font-extrabold text-3xl text-slate-900">Your Progress</h1>
        <p className="text-slate-600 mt-1">Everything you've completed so far.</p></header>
      {items.length === 0 ? (
        <div className="rle-card p-8 text-slate-600">No activity yet. Complete a lesson or mission to see it here.</div>
      ) : (
        <div className="rle-card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-left"><tr>
              <th className="p-3 font-semibold">Type</th>
              <th className="p-3 font-semibold">Item</th>
              <th className="p-3 font-semibold">Status</th>
              <th className="p-3 font-semibold">Completed</th>
            </tr></thead>
            <tbody>{items.map((p) => (
              <tr key={p.id} className="border-t border-slate-100" data-testid={`progress-row-${p.id}`}>
                <td className="p-3">{p.lesson_id ? "Lesson" : "Mission"}</td>
                <td className="p-3 font-mono text-xs">{p.lesson_id || p.scenario_id}</td>
                <td className="p-3">{p.completed ? "Completed" : "In progress"}</td>
                <td className="p-3 text-slate-500">{p.completed_at ? new Date(p.completed_at).toLocaleString() : "—"}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
